import React from 'react'

import type { Product } from '../../types'
import * as S from './styled'

type ProductStockVariantsTooltipContentProps = {
  variants: Product['stock']['variants']
}

export const ProductStockVariantsTooltipContent = ({
  variants,
}: ProductStockVariantsTooltipContentProps) => {
  return (
    <S.Container>
      <S.Header>
        <S.Label>Variant</S.Label>
        <S.Label>Stock</S.Label>
      </S.Header>
      <S.Content>
        {variants?.map((stockVariant) => (
          <S.Variant key={stockVariant.variant}>
            <S.Name>{stockVariant.variant}</S.Name>
            <S.StockCount>
              {stockVariant.stock?.type === 'UNLIMITED' ? 'Unlimited' : stockVariant.stock.quantity}
            </S.StockCount>
          </S.Variant>
        ))}
      </S.Content>
    </S.Container>
  )
}
